module.exports = __webpack_public_path__ + "fonts/sole.07a6da2.ttf";